import React from "react";
import Text from "../../Text";

export function useCardElement() {
  const renderCardElement = (Element) => {
    if (!Element) {
      return null;
    }
    if (typeof Element === "string") {
      return (
        <Text fontSize="1.3em" align="center">
          {Element}
        </Text>
      );
    }
    return Element;
  };
  return renderCardElement;
}



// WEBPACK FOOTER //
// ./src/_components/Card/hooks/index.jsx